import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/App.css'
import 'bootstrap/dist/css/bootstrap.css';
import {BrowserRouter} from 'react-router-dom';
import '../src/index.css';
import App from '../src/App';
import 'react-multi-carousel/lib/styles.css';



 
!!!module.loaded ?  
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
 <BrowserRouter>  
   <App/>    
  </BrowserRouter>)
  :
ReactDOM.hydrateRoot(document.getElementById('root') as HTMLElement,
<BrowserRouter>
 <App />    
</BrowserRouter>
);